<div class="container">
  <div
    class="modal-custom modal fade"
    id="modalLoginEmail"
    data-keyboard="false"
    data-backdrop="static"
    role="dialog"
    aria-labelledby="modalNoteResumeLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal_header">
          <p class="header-title">Login</p>
          <a (click)="closeLoginMock()" class="btn" type="button">
            <svg-icon src="/assets/images/close.svg"></svg-icon>
          </a>
        </div>
        <div class="modal-body modal-body--small">
          <div
            class="d-flex align-items-center flex-wrap mb-1"
            style="gap: 17px"
          >
            <div class="input-material" style="flex-grow: 3">
              <input
                id="start"
                type="text"
                class="form-control"
                [(ngModel)]="modelEmailMock"
              />
              <label for="start">{{ "email" | translate }}</label>
            </div>
          </div>
          <button
            class="btn btn-block btn-warning mt-3"
            (click)="handleLogin()"
          >
            {{ "entrar" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="reModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Informar o RE</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            (click)="closeLoginMock()"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div
            class="d-flex align-items-center flex-wrap mb-1"
            style="gap: 17px"
          >
            <div>
              <span
                >Favor informar seu número de registro, caso a informação
                inserida seja incorreta somente o administrator poderá
                alterar.</span
              >
            </div>
            <div class="input-material" style="flex-grow: 3">
              <input
                id="start"
                type="text"
                class="form-control"
                [(ngModel)]="modelReMock"
              />
              <label for="start">RE</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-block btn-warning mt-3" (click)="onLogin()">
            {{ "Enviar" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
